import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { CalendarToday } from '@material-ui/icons';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';
import { FormattedDate } from 'react-intl';

import { Scalars } from '../../../graphql/generated/graphql';
import { toJSDate } from '../../../utility/graphql/datetime';
import { SPACING_UNIT } from '../../constant/spacing';

interface Props {
  dueDate: Scalars['ISO8601String'];
  className?: string;
}

const DeliveryDueDate = ({ dueDate, className }: ClassAttributes<HTMLElement> & Props) => (
  <Root className={className}>
    <CalendarToday style={{ fontSize: 20 }} />
    <Spacer />
    <FormattedMessage id="delivery_due_date.label" />
    :<Spacer />
    <FormattedDate
      value={toJSDate(dueDate)}
      year="numeric"
      month="short"
      day="2-digit"
      hour="2-digit"
      minute="2-digit"
    />
  </Root>
);

const Root = styled(Typography)({
  display: 'inline-flex',
  alignItems: 'center',
  fontSize: '0.8125rem',
  fontWeight: 500,
});

const Spacer = styled('span')({
  marginRight: SPACING_UNIT,
});

export default DeliveryDueDate;
